import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { Header, Footer } from "@/components/Layout";
import { CartDrawer } from "@/components/CartDrawer";

import Home from "@/pages/Home";
import Catalogo from "@/pages/Catalogo";
import ProductoDetail from "@/pages/ProductoDetail";
import Carrito from "@/pages/Carrito";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Cuenta from "@/pages/Cuenta";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import AdminCoupons from "@/pages/admin/AdminCoupons";
import AdminBanners from "@/pages/admin/AdminBanners";
import AdminCampaigns from "@/pages/admin/AdminCampaigns";

const StorefrontLayout = ({ children }) => (
  <>
    <Header />
    <main className="min-h-[60vh]">{children}</main>
    <Footer />
    <CartDrawer />
  </>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Toaster position="top-center" richColors />
            <Routes>
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="productos" element={<AdminProducts />} />
                <Route path="pedidos" element={<AdminOrders />} />
                <Route path="clientes" element={<AdminCustomers />} />
                <Route path="cupones" element={<AdminCoupons />} />
                <Route path="banners" element={<AdminBanners />} />
                <Route path="campanas" element={<AdminCampaigns />} />
              </Route>

              <Route path="/" element={<StorefrontLayout><Home /></StorefrontLayout>} />
              <Route path="/catalogo" element={<StorefrontLayout><Catalogo /></StorefrontLayout>} />
              <Route path="/catalogo/:categorySlug" element={<StorefrontLayout><Catalogo /></StorefrontLayout>} />
              <Route path="/producto/:slug" element={<StorefrontLayout><ProductoDetail /></StorefrontLayout>} />
              <Route path="/carrito" element={<StorefrontLayout><Carrito /></StorefrontLayout>} />
              <Route path="/checkout-success" element={<StorefrontLayout><CheckoutSuccess /></StorefrontLayout>} />
              <Route path="/login" element={<StorefrontLayout><Login /></StorefrontLayout>} />
              <Route path="/register" element={<StorefrontLayout><Register /></StorefrontLayout>} />
              <Route path="/cuenta" element={<StorefrontLayout><Cuenta /></StorefrontLayout>} />
            </Routes>
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
